import { identityScript, viewDocument } from "./document.js";

// `get_medications`: read-only. Nothing here calls a tool.
const body = `<div id="root"><p class="muted">Loading medications…</p></div>`;
const script = `${identityScript}
var root = document.getElementById("root");
function table(head, rows) {
  return '<table><thead><tr>' + head.map(function (h) { return '<th>' + h + '</th>'; }).join("") + '</tr></thead><tbody>' +
    rows.map(function (r) { return '<tr>' + r.map(function (c) { return '<td>' + view.esc(c) + '</td>'; }).join("") + '</tr>'; }).join("") + '</tbody></table>';
}
view.onResult(function (p) {
  if (!p || !p.active) { root.textContent = "No medications to show."; return; }
  var html = identityHtml(p.patient, p.encounter) + '<h2>Active</h2>';
  html += p.active.length ? table(["Medication", "Directions", "Since"], p.active.map(function (m) { return [m.name + " " + m.strength, m.directions, m.date]; })) : '<p class="muted">None.</p>';
  if (p.prescriptions.length) html += '<h2>Prescribed this visit</h2>' + table(["Medication", "Directions", "Status"], p.prescriptions.map(function (o) { return [o.name + " " + (o.strength || ""), o.directions || "", o.status]; }));
  if (p.historical.length) html += '<h2>Historical</h2>' + table(["Medication", "Directions", "Date"], p.historical.map(function (m) { return [m.name + " " + m.strength, m.directions, m.date]; }));
  root.innerHTML = html;
  view.reportSize();
});
`;
export const medicationsView = viewDocument("Medications", body, script);
